import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider as MuiThemeProvider, CssBaseline } from '@mui/material';
import getTheme from './theme';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';
import { useSelector } from 'react-redux';
import { ThemeProvider } from './ThemeContext';
import { useContext } from 'react';
import { ThemeContext } from './ThemeContext';

const Root = () => {
  const lang = useSelector((state) => state.i18n.lang);
  const direction = lang === 'ar' ? 'rtl' : 'ltr';
  const { mode } = useContext(ThemeContext);

  React.useEffect(() => {
    document.documentElement.setAttribute('dir', direction);
    document.documentElement.setAttribute('lang', lang);
    document.body.className = mode + '-mode';
  }, [direction, lang, mode]);

  const theme = React.useMemo(() => getTheme(direction, mode), [direction, mode]);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </MuiThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <Root />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();